














import {Component, Prop, Vue} from 'vue-property-decorator';
import Checkbox from './input/Checkbox.vue';

@Component({
  name: 'PolicyRow',
  components: {
    Checkbox,
  },
})
export default class PolicyRow extends Vue {
  @Prop() checked!: boolean;
  @Prop() isObligatory: boolean | undefined;
}
